<template>
  <div class="chart-container" :style="{ height: typeof height === 'number' ? height + 'px' : String(height), width: '100%' }">
    <Doughnut :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'

ChartJS.register(ArcElement, Tooltip, Legend)

export default {
  name: 'DonutChart',
  components: { Doughnut },
  props: {
    totalSales: { type: Number, required: true },
    salesTarget: { type: Number, required: true },
    height: { type: [Number, String], default: 200 }
  },
  computed: {
    chartData() {
      const goal = this.salesTarget > 0 ? this.salesTarget : 1
      const total = Math.max(0, Number(this.totalSales) || 0)
      const achieved = Math.min(total, goal)
      const over = Math.max(total - goal, 0)
      const remaining = Math.max(goal - achieved, 0)

      // Single ring logic:
      // - Blue fills to goal
      // - Turns green for any amount over the goal
      const data = over > 0
        ? [goal, over] // reached + extra
        : [achieved, remaining]

      const createGoldGradient = (ctx, chartArea) => {
        const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
        gradient.addColorStop(0, '#A67C00'); // slightly lighter dark gold base
        gradient.addColorStop(0.5, '#DAA520'); // balanced mid gold
        gradient.addColorStop(1, '#FFD700'); // bright golden top (consistent tone)
        return gradient;
      };

      const colors = (ctx) => {
        const chart = ctx.chart;
        const { ctx: c, chartArea } = chart;
        if (!chartArea) return over > 0 ? ['#2C74B3', '#FFD700'] : ['#2C74B3', '#E0E0E0'];
        return over > 0
          ? ['#2C74B3', createGoldGradient(c, chartArea)]
          : ['#2C74B3', '#E0E0E0'];
      };

      return {
        labels: ['Progress', 'Remaining/Overage'],
        datasets: [{
          data,
          backgroundColor: (ctx) => colors(ctx),
          borderWidth: 0,
          cutout: '65%',
          rotation: 0,
          circumference: 360
        }]
      }
    },
    chartOptions() {
      const fmt = (n) => `$${Number(n || 0).toFixed(2)}`
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (ctx) => {
                const val = ctx.raw
                const color = ctx.dataset.backgroundColor[ctx.dataIndex]
                if (color === '#2E7D32') return `Over Goal: ${fmt(val)}`
                if (color === '#2C74B3') return `Achieved: ${fmt(val)}`
                return `Remaining: ${fmt(val)}`
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.chart-container { position: relative; width: 100%; }
</style>